import request from "../utils/request";
export function getRemoteConfigList(params) {
    const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    return request({
        url: `/remoteConfig/listAll?${queryString}`,
        method: "get"
    });
}

export function getRemoteConfigById(params) {
    const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    return request({
        url: `/remoteConfig/getById?${queryString}`,
        method: "get"
    });
}


export function updateRemoteConfigById(params) {
    return request({
        url: `/remoteConfig/updateConfig`,
        method: "post",
        data: params
    });
}


export function createRemoteConfig(params) {
    return request({
        url: `/remoteConfig/addConfig`,
        method: "post",
        data: params
    });
}


export function updateRemoteConfigStatus(params) {
    const queryString = Object.keys(params)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
    return request({
        url: `/remoteConfig/updateConfigStatus?${queryString}`,
        method: "get"
    });
}